export default __webpack_public_path__ + "static/Indian Express-1c1f362e8cb65e435ecbc82317b5dc43.jpg";